function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { createErrorHandler, deepEquals, getDefaultFormState, ROOT_SCHEMA_PREFIX, toErrorList as _toErrorList, toErrorSchema, unwrapErrorHandler, validationDataMerge, withIdRefPrefix } from '@rjsf/utils';
import createAjvInstance from "./createAjvInstance";
/** `ValidatorType` implementation that uses the AJV 6 validation mechanism.
 *
 * @deprecated in favor of the `@rjsf/validator-ajv8
 */

var AJV6Validator = /*#__PURE__*/function () {
  /** Constructs an `AJV6Validator` instance using the `options`
   *
   * @param options - The `CustomValidatorOptionsType` options that are used to create the AJV instance
   */
  function AJV6Validator(options) {
    _classCallCheck(this, AJV6Validator);

    var additionalMetaSchemas = options.additionalMetaSchemas,
        customFormats = options.customFormats,
        ajvOptionsOverrides = options.ajvOptionsOverrides;
    this.ajv = createAjvInstance(additionalMetaSchemas, customFormats, ajvOptionsOverrides);
  }
  /** Converts an `errorSchema` into a list of `RJSFValidationErrors`
   *
   * @param errorSchema - The `ErrorSchema` instance to convert
   * @param [fieldPath=[]] - The current field path, defaults to [] if not specified
   * @deprecated - Use the `toErrorList()` function provided by `@rjsf/utils` instead. This function will be removed in
   *        the next major release.
   */


  _createClass(AJV6Validator, [{
    key: "toErrorList",
    value: function toErrorList(errorSchema) {
      var fieldPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return _toErrorList(errorSchema, fieldPath);
    }
    /** Transforming the error output from ajv to format used by @rjsf/utils.
     * At some point, components should be updated to support ajv.
     *
     * @param errors - The list of AJV errors to convert to `RJSFValidationErrors`
     * @private
     */

  }, {
    key: "transformRJSFValidationErrors",
    value: function transformRJSFValidationErrors() {
      var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return errors.map(function (e) {
        var dataPath = e.dataPath,
            keyword = e.keyword,
            message = e.message,
            params = e.params,
            schemaPath = e.schemaPath;
        var property = "".concat(dataPath); // put data in expected format

        return {
          name: keyword,
          property: property,
          message: message,
          params: params,
          stack: "".concat(property, " ").concat(message).trim(),
          schemaPath: schemaPath
        };
      });
    }
    /** Runs the pure validation of the `schema` and `formData` without any of the RJSF functionality. Provided for use
     * by the playground. Returns the `errors` from the validation
     *
     * @param schema - The schema against which to validate the form data   * @param schema
     * @param formData - The form data to validate
     */

  }, {
    key: "rawValidation",
    value: function rawValidation(schema, formData) {
      var validationError = undefined;

      try {
        this.ajv.validate(schema, formData);
      } catch (err) {
        validationError = err;
      }

      var errors = this.ajv.errors || undefined; // Clear errors to prevent persistent errors, see #1104

      this.ajv.errors = null;
      return {
        errors: errors,
        validationError: validationError
      };
    }
    /** This function processes the `formData` with an optional user contributed `customValidate` function, which receives
     * the form data and a `errorHandler` function that will be used to add custom validation errors for each field. Also
     * supports a `transformErrors` function that will take the raw AJV validation errors, prior to custom validation and
     * transform them in what ever way it chooses.
     *
     * @param formData - The form data to validate
     * @param schema - The schema against which to validate the form data
     * @param [customValidate] - An optional function that is used to perform custom validation
     * @param [transformErrors] - An optional function that is used to transform errors after AJV validation
     * @param [uiSchema] - An optional uiSchema that is passed to `transformErrors` and `customValidate`
     */

  }, {
    key: "validateFormData",
    value: function validateFormData(formData, schema, customValidate, transformErrors, uiSchema) {
      var rootSchema = schema;
      var rawErrors = this.rawValidation(schema, formData);
      var validationError = rawErrors.validationError;
      var errors = this.transformRJSFValidationErrors(rawErrors.errors);
      var noProperMetaSchema = validationError && validationError.message && validationError.message.includes('no schema with key or ref ');

      if (noProperMetaSchema) {
        errors = [].concat(_toConsumableArray(errors), [{
          stack: validationError.message
        }]);
      }

      if (typeof transformErrors === 'function') {
        errors = transformErrors(errors, uiSchema);
      }

      var errorSchema = toErrorSchema(errors);

      if (noProperMetaSchema) {
        errorSchema = _objectSpread(_objectSpread({}, errorSchema), {
          $schema: {
            __errors: [validationError.message]
          }
        });
      }

      if (typeof customValidate !== 'function') {
        return {
          errors: errors,
          errorSchema: errorSchema
        };
      } // Include form data with undefined values, which is required for custom validation.


      var newFormData = getDefaultFormState(this, schema, formData, rootSchema, true);
      var errorHandler = customValidate(newFormData, createErrorHandler(newFormData), uiSchema);
      var userErrorSchema = unwrapErrorHandler(errorHandler);
      return validationDataMerge({
        errors: errors,
        errorSchema: errorSchema
      }, userErrorSchema);
    }
    /**
     * This function checks if a schema needs to be added and if the root schemas don't match it removes the old root schema from the ajv instance and adds the new one.
     * @param rootSchema - The root schema used to provide $ref resolutions
     */

  }, {
    key: "handleSchemaUpdate",
    value: function handleSchemaUpdate(rootSchema) {
      var _a;

      var rootSchemaId = ROOT_SCHEMA_PREFIX; // add the rootSchema ROOT_SCHEMA_PREFIX as id.
      // if schema validator instance doesn't exist, add it.
      // else 'handleRootSchemaChange' should be called if the root schema changes so we don't have to remove and recompile the schema every run.

      if (this.ajv.getSchema(ROOT_SCHEMA_PREFIX) === undefined) {
        this.ajv.addSchema(rootSchema, ROOT_SCHEMA_PREFIX);
      } else if (!deepEquals(rootSchema, (_a = this.ajv.getSchema(ROOT_SCHEMA_PREFIX)) === null || _a === void 0 ? void 0 : _a.schema)) {
        this.ajv.removeSchema(rootSchemaId);
        this.ajv.addSchema(rootSchema, rootSchemaId);
      }
    }
    /** Validates data against a schema, returning true if the data is valid, or
     * false otherwise. If the schema is invalid, then this function will return
     * false.
     *
     * @param schema - The schema against which to validate the form data   * @param schema
     * @param formData- - The form data to validate
     * @param rootSchema - The root schema used to provide $ref resolutions
     */

  }, {
    key: "isValid",
    value: function isValid(schema, formData, rootSchema) {
      try {
        this.handleSchemaUpdate(rootSchema); // then rewrite the schema ref's to point to the rootSchema
        // this accounts for the case where schema have references to models
        // that lives in the rootSchema but not in the schema in question.

        var result = this.ajv.validate(withIdRefPrefix(schema), formData);
        return result;
      } catch (e) {
        return false;
      }
    }
  }]);

  return AJV6Validator;
}();

export { AJV6Validator as default };